module.exports = __webpack_public_path__ + "static/members-1afaf176eb91ede1411d02f4533acfce.jpg";